module.exports = __webpack_public_path__ + "static/media/testimonials.3035aac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/others/testimonials.png
// module id = 1231
// module chunks = 0